export default __webpack_public_path__ + "static/contact-img-bd24afbd1891d08512c95d3ac734b694.png";